import { SET_BOOKMARK_DISCARD } from '../actions/bookmark/constants';

const initialState = {
  discardBookmark: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_BOOKMARK_DISCARD:
      return {
        ...state,
        discardBookmark: action.payload,
      };
    default:
      return state;
  }
};
